import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatRadioModule } from '@angular/material/radio'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardClientAccountUtilsModule } from 'libs/gb-dashboard/client-account/utils/src/lib/gb-dashboard-client-account-utils.module'
import { GbDashboardPresenterDataAccessProjectorTemplatesModule } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/gb-dashboard-presenter-data-access-projector-templates.module'
import { GbDashboardPresenterDataAccessPresenterWidgetsTemplateModule } from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/gb-dashboard-presenter-data-access-presenter-widgets-template.module'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import {
  GbPresenterBottomToolbarSlotDirective,
  GbPresenterConfigSidebarHeaderSlotDirective,
  GbPresenterEditComponent,
  GbPresenterElementsSidebarHeaderSlotDirective,
} from '../gb-presenter-edit/gb-presenter-edit.component'
import { GbPresenterTemplateConfigComponent } from '../gb-presenter-template-config/gb-presenter-template-config.component'
import { PRESENTER_CONTEXT } from '../../../../utils/src/lib/gb-presenter-context/presenter-context.token'
import { ActivatedRoute } from '@angular/router'
import { ProjectorTemplatesFacade } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.facade'
import * as ProjectorTemplateActions from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.actions'
import { ProjectorTemplatesEntity } from 'libs/gb-dashboard/presenter/data-access-projector-templates/src/lib/+state/projector-templates.models'
import { PresenterContextService } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-context/presenter-context.service'
import { PresenterContextEnum } from 'libs/gb-dashboard/presenter/utils/src/lib/gb-presenter-context/presenter-context.enum'

@UntilDestroy()
@Component({
  selector: 'gb-presenter-template',
  imports: [
    CommonModule,
    GbPresenterEditComponent,
    GbPresenterElementsSidebarHeaderSlotDirective,
    GbPresenterBottomToolbarSlotDirective,
    GbPresenterConfigSidebarHeaderSlotDirective,
    GbPresenterTemplateConfigComponent,
    GbDashboardPresenterDataAccessProjectorTemplatesModule,
    GbDashboardPresenterDataAccessPresenterWidgetsTemplateModule,
    GbDashboardSharedUiModule,
    GbDashboardClientAccountUtilsModule,
    MatRadioModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
  ],
  templateUrl: './gb-presenter-template.component.html',
  styleUrl: './gb-presenter-template.component.scss',
  providers: [
    {
      provide: PRESENTER_CONTEXT,
      useValue: {
        mode: 'template',
      },
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterTemplateComponent implements OnInit, OnDestroy {
  selectedTemplate$ = this.projectorTemplatesFacade.selectedProjectorTemplate$

  @ViewChild('templateConfig') templateConfig!: GbPresenterTemplateConfigComponent

  constructor(
    private activatedRoute: ActivatedRoute,
    private projectorTemplatesFacade: ProjectorTemplatesFacade,
    private presenterContextService: PresenterContextService,
  ) {}

  getFormValues(): Partial<ProjectorTemplatesEntity> {
    return this.templateConfig.form.value
  }

  ngOnInit(): void {
    this.presenterContextService.setMode(PresenterContextEnum.TEMPLATE)

    this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((data) => {
      const uuid = data['uuid']

      this.presenterContextService.setTemplateUuid(uuid)
      this.projectorTemplatesFacade.dispatch(ProjectorTemplateActions.loadProjectorTemplates())
      this.projectorTemplatesFacade.dispatch(ProjectorTemplateActions.selectProjectorTemplate({ uuid }))
      this.projectorTemplatesFacade.dispatch(ProjectorTemplateActions.initSelectedProjectorTemplate())
    })
  }

  ngOnDestroy() {
    this.presenterContextService.setMode(PresenterContextEnum.AUCTION)
    this.presenterContextService.setTemplateUuid(undefined)
  }

  saveTemplate() {
    this.projectorTemplatesFacade.dispatch(
      ProjectorTemplateActions.updateProjectorTemplate({
        template: this.getFormValues(),
        updateConfig: true,
      }),
    )
  }
}
